<template>
  <div class="addChemical">
    <div class="title">
      危险货物运输安全卡 <span>安全卡信息详情</span>
    </div>
    <div class="detail_info">
      <div class="info_title">安全卡信息详情</div>
      <div class="chemical">
        <div class="back"
             @click="handleBackClick">返回</div>
        <div class="to_top"
             id="scroller-box"
             @click="scrollToTop"></div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>化学品名称：
          </label>
          <div>{{data.chemicalsName}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span></span>别名：
          </label>
          <div>{{data.alias}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>英文名称：
          </label>
          <div>{{data.englishName}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span></span>化学品分类：
          </label>
          <div>{{data.chemicalClassification}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>危险品类别：
          </label>
          <div>{{data.dangerousGoodsCategory}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>类别图标：
          </label>
          <div>
            <img :src="imgurl"
                 alt=""><br><span>{{data.imageType}}</span><br></div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>UN编码：
          </label>
          <div>{{data.unCode}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>CN编码：
          </label>
          <div>{{data.cnCode}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>化学式：
          </label>
          <div>{{data.chemicalFormula}}</div>
        </div>
        <div class="borderLine"></div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>危险性：
          </label>
          <div>{{data.danger}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>泄露处理：
          </label>
          <div>{{data.leakageTreatment}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>储运要求：
          </label>
          <div>{{data.storageTransportationRequirements}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>急救：
          </label>
          <div>{{data.firstAid}} </div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>灭火方法：
          </label>
          <div>{{data.extinguishingMethod}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span>*</span>防护措施：
          </label>
          <div>{{data.protectiveMeasures}}</div>
        </div>
        <div class="chemical_list">
          <label for="">
            <span></span>备注：
          </label>
          <div>{{data.remarks}}</div>
        </div>
        <!-- <div class="chemical_list">
                    <label ></label>
                    <el-button @click="handleSaveClick">保存</el-button>
                    <el-button @click="handleCancelClick">取消</el-button>
                </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import {
  getSafetyCardDetail
} from 'apis/index'
export default {
  data () {
    return {
      id: '',
      data: {
      },
      imgurl: ''

    }
  },
  methods: {
    handleBackClick () { // 返回
      this.$router.go(-1)
    },
    scrollToTop () { // 返回顶部
      var addChemical = document.getElementsByClassName('addChemical')[0]
      addChemical.scrollTop = 0
    },
    getData () { // 初始化页面
      getSafetyCardDetail({
        id: this.id
      }).then(res => {
        // console.log(res)
        if (res.data.code === 0) {
          this.imgurl = res.data.data.typeIcon.imgUrl
          this.data = res.data.data
        }
      })
    }
  },
  mounted () {
    this.id = this.$route.query.item
    if (this.id) {
      this.getData()
    }
  }
}
</script>
<style lang="stylus">
.addChemical
  overflow-y auto
  .title
    padding-left 20px
    height 50px
    line-height 50px
    font-size 12px
    color #858C96
    background url('../../../../assets/images/01/nav_arrow.png') no-repeat top 23px left 137px #F7F9FB
    span
      color #212832
      margin-left 20px
  .detail_info
    width calc(100% - 40px)
    background #fff
    overflow hidden
    margin 0 auto
    .info_title
      height 46px
      line-height 46px
      padding-left 46px
      color #212832
      background url('../../../../assets/images/gaoji_cheliang.png') no-repeat center left 15px
    .chemical
      padding-top 20px
      overflow hidden
      padding-bottom 10px
      border-top 1px solid #CFD5DC
      position relative
      color #212832
      .pay_success
        background url('../../../../assets/images/09/success.png') no-repeat center left 85px
      .pay_failed
        background url('../../../../assets/images/09/failure.png') no-repeat center left 85px
      .pay_wait
        background url('../../../../assets/images/09/pay.png') no-repeat center left 85px
      .back
        width 78px
        height 28px
        line-height 28px
        border-radius 3px
        color #FFFFFF
        text-align center
        cursor pointer
        background #1b88ee
        position absolute
        top 34px
        right 21px
      .to_top
        width 40px
        height 40px
        cursor pointer
        position fixed
        top 70%
        right 70px
        background url('../../../../assets/images/09/top.png') no-repeat center center
        &:hover
          background url('../../../../assets/images/09/top_hover.png') no-repeat center center
      .chemical_list
        width 100%
        min-height 50px
        margin-bottom 10px
        white-space pre-wrap
        label
          display inline-block
          width 168px
          text-align right
          color #5E656F
          float left
          margin-top 6px
          span
            color #FF344A
            margin-right 5px
        div
          display inline-block
          color #212832
          width 536px
          margin-left 10px
          line-height 20px
          img
            width 40px
        .chemical_pay
          color #FF6F12
        .el-button
          background #1B88EE
          padding 6px 24px
          border 1px solid #1B88EE
          color #fff
          margin-right 20px
          span
            width 100%
            color #fff
            font-size 12px
          &:nth-last-child(1)
            background #fff
            padding 6px 24px
            border 1px solid #CFD5DC
            color #1b88ee
            span
              color #1b88ee
      .borderLine
        height 40px
        border-top 1px dashed #ccc
        margin-top 25px
</style>
